import confirmLogoutDialog from './ConfirmLogoutDialog.html';

/*****************************************************************************************
 * Confirm dialog allows user to logout or switch organizations.
 *****************************************************************************************/
/* @ngInject */ export function ConfirmLogoutDialogService($uibModal) {
  this.show = function () {
    var dialog = $uibModal.open({
      animation: true,
      template: confirmLogoutDialog,
      controller: controller,
      size: 'sm',
      backdrop: 'static',
      windowClass: 'menu-modal-popup'
    });

    return dialog.result;
  };
}

/***************************************************************************
 * Controller
 ***************************************************************************/
/* @ngInject */ function controller(
  $scope,
  $uibModalInstance,
  CommonSvc,
  Alert,
  OrgSelectDialog,
  SERVER
) {
  /*------------------------------------------*/
  /* Get the list of available organizations. */
  /*------------------------------------------*/
  var mOrgs = [];
  CommonSvc.getOrgs().then(function (resp) {
    mOrgs = resp.data;
  });

  /** @property {function} cancel  Closes the modal dialog. */
  $scope.cancel = function () {
    $uibModalInstance.dismiss('Close and remain on page');
  };

  /** @property {function} logout  Logout current user and redirect to application root/homepage. */
  $scope.logout = function () {
    CommonSvc.logout().then(function () {

      window.location.replace('/');
    });
  };

  /** @property {function} showSwitch  Returns true if user has access to multiple organizations. */
  $scope.showSwitch = function () {
    return SERVER.productID != 'PTAEZ' && mOrgs.length > 1;
  };

  /** @property {function} switchAccounts  Use OrgSelectDialog to manage available accounts. */
  $scope.switchAccounts = function () {
    $uibModalInstance.close('Switch Accounts');

    OrgSelectDialog.show(mOrgs, function (orgID) {
      Alert.confirm(
        'Are you sure you want to switch accounts?',
        'Please Confirm'
      ).then(function () {
        CommonSvc.switchOrg(orgID).then(function () {
          /**
           * We remove the menu for this org from session storage to ensure that the menu is completely
           * fresh on each login. This is accomodate for any Access Control menu changes that could have occured
           * from a release while the user is using the application.
           */
          var menuKey = Object.keys(sessionStorage).find(
            (key) => key.includes('menu-') && key.includes(`orgID:${orgID}`)
          );

          if (menuKey) {
            sessionStorage.removeItem(menuKey);
          }

          window.location.reload();
        });
      });
    });
  };
}
